import "./GameSquare.style.css";

import { ReactElement, useEffect, useState } from "react";
import { GameArrowDownIcon } from "../../../components/icons/GameArrowDownIcon";
import { GameArrowUpIcon } from "../../../components/icons/GameArrowUpIcon";
import { AnswerStatus } from "../../../utils/enums/AnswerStatus";

interface GameSquareProps {
  value: ReactElement;
  answerStatus: AnswerStatus;
  animationDelay?: number;
}

export const GameSquare = ({
  value,
  answerStatus,
  animationDelay = 200,
}: GameSquareProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpened(true);
    }, animationDelay);

    return () => clearTimeout(timer);
  }, [animationDelay]);

  return (
    <div
      className={`game-square game-square_${
        isOpened ? "opened" : "closed"
      } game-square_${answerStatus}`}
    >
      {value}
      {answerStatus === AnswerStatus.WrongMore && (
        <GameArrowUpIcon className="up-arrow" />
      )}
      {answerStatus === AnswerStatus.WrongLess && (
        <GameArrowDownIcon className="down-arrow" />
      )}
    </div>
  );
};
